import Repository from "./Repository";

const ADD_ENTRY = "create";
const DELETE_ENTRY = "delete";
const UPDATE_ENTRY = "update";
const GET_ENTRY = "get";
const GET_ONE_ENTRY = "getSingle";
const FILTER_BY_CATEGORY = "filterByCategory";
const MAIN_GET = "mainGET";
const PRODUCT_IMAGE = "addProductImage";

export default {
  getAllCollections(payload) {
    console.log(payload, "repository");
    return Repository.post(transformRoute(GET_ENTRY), payload);
  },
  getMainAllCollection(payload) {
    return Repository.post(transformRoute(MAIN_GET), payload);
  },
  getOneCollection(payload) {
    return Repository.post(transformRoute(GET_ONE_ENTRY), payload);
  },
  filterByCategory(payload) {
    return Repository.post(transformRoute(FILTER_BY_CATEGORY), payload);
  },
  addOneCollection(payload) {
    return Repository.post(transformRoute(ADD_ENTRY), payload);
  },
  productImage(payload) {
    return Repository.post(transformRoute(PRODUCT_IMAGE), payload);
  },
  deleteOneCollection(payload) {
    return Repository.post(transformRoute(DELETE_ENTRY), payload);
  },
};

const transformRoute = (route) => {
  return `/product/${route}`;
};
